export default __webpack_public_path__ + "static/media/kornyezetunkMegovasa.9befae8b.png";